import {inject} from 'aurelia-framework';  
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { OrgTypesAdminAPI } from '../../services/admin/orgTypesAdminAPI';

@inject(AuthService, Router, OrgTypesAdminAPI, UserMessageService)
export class OrgTypes {
    constructor(authService, router, api, userMessageService) {
        
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;
        
        this.saving = false;
    }

    activate(params) {
        this.loading = true;
        this.load();        
    }

    load() {
        this.api.getList(
            this.authService.getUser().token, 
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
    }
  
    save() {
        console.log("start save");
        console.log(this.orgTypes);
        console.log("end save");
        this.saving = true;
        this.api.save(
            this.orgTypes, 
            this.authService.getUser().token, 
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
        
    }

    saveLoadSuccess(data) {
        this.loading = false;
        this.orgTypes = data;
       console.log(data);
        if(this.saving)
            this.userMessageService.setUserMessage("user", "Saved!");
        this.saving = false;
    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
        this.loading = false;
        
    }

    itemChanged(item) {
        item.changed = true;

       
    }

    deleteItem(item, index) {
        if(item.new) {
            this.orgTypes.splice(index, 1);
        } else {
            if(confirm("Delete organization type " + item.display_value + "?")) {
                this.saving = true;
                this.api.delete(
                    item, 
                    this.authService.getUser().token, 
                    this.saveLoadSuccess.bind(this), 
                    this.saveLoadError.bind(this));
            }
        }
    }

    
    addOrgType() {
        this.orgTypes.push({
          "display_value": "",
          "new": true
        });
      }
    
}
